import { Switchboard } from "../../events";
export class Context {
    constructor(map) {
        this.exit_contexts = [];
        this.receiver = Switchboard.get_receiver("MOVEMENT");
        this.name = 'base';
        this.has_table = false;
        this.has_markers = false;
        this.has_measure = false;
        this.has_edit = false;
        this.map = map;
        this.max_zoom = map.view.getMaxZoom();
        this.receiver.on('zoom', (ctx_name) => {
            if (this.name === ctx_name)
                this.zoom(false);
        });
    }
    get view() { return this.map.getView(); }
    get full_extent() {
        return this.map.get_default_extent().unwrapOr([0, 0, 0, 0]);
    }
}
